export default __webpack_public_path__ + "static/media/star.0a89de19.svg";